
import { ArrowUpDown } from "lucide-react";
import { TableHeader, TableRow, TableHead } from "@/components/ui/table";
import { SortColumn, SortDirection } from "@/hooks/useUserManagement";

interface UsersTableHeaderProps {
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
}

export function UsersTableHeader({ sortColumn, sortDirection, onSort }: UsersTableHeaderProps) {
  const getSortIcon = (column: SortColumn) => {
    if (sortColumn === column) {
      return <ArrowUpDown className="ml-2 h-4 w-4" />;
    }
    return <ArrowUpDown className="ml-2 h-4 w-4 text-muted-foreground/30" />;
  };

  return (
    <TableHeader>
      <TableRow>
        <TableHead 
          className="cursor-pointer hover:text-foreground transition-colors"
          onClick={() => onSort("email")}
        >
          Email {getSortIcon("email")}
        </TableHead>
        <TableHead 
          className="cursor-pointer hover:text-foreground transition-colors"
          onClick={() => onSort("created_at")}
        >
          Criado em {getSortIcon("created_at")}
        </TableHead>
        <TableHead 
          className="cursor-pointer hover:text-foreground transition-colors"
          onClick={() => onSort("updated_at")}
        >
          Atualizado em {getSortIcon("updated_at")}
        </TableHead>
        <TableHead className="w-[100px]">Ações</TableHead>
      </TableRow>
    </TableHeader>
  );
}
